import { Component, Injector, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JkBaseOption, jkRestReturn } from 'jk-service';
import { MaterialModule } from 'jk-service';
import { UtymdService, templateUrlConfigUty } from '../_service_uty';
import { Utymd } from '../_entity_uty';
import { JkDialogEditComponent } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';


@Component({
  selector: 'app-utymd-edit',
  templateUrl: './utymd-editPkg.component.html',
  styleUrls: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [JackBaseComponentModule, MaterialModule],
})

export class UtymdEditComponent extends JkDialogEditComponent<UtymdService, Utymd> {
  override dialogRef: MatDialogRef<UtymdEditComponent>;
  override data: jkRestReturn;

  override srv!: UtymdService;
  constructor() {
    const injector = inject(Injector);
    const dialogRef = inject<MatDialogRef<UtymdEditComponent>>(MatDialogRef);
    const data = inject<jkRestReturn>(MAT_DIALOG_DATA);

    super(injector, dialogRef, data);

    this.dialogRef = dialogRef;
    this.data = data;
  }


}
